import { css, keyframes } from '@emotion/react';
import styled from '@emotion/styled';
import { SHOT_CONFIG } from '../constants/shotConfig';

const FLASH_TIME = 0.6;
const flashAnimation = keyframes`
  10% { opacity: 0.9; }
  40% { opacity: 0.9; }
  100% { opacity: 0; }
`;

export const Flash = styled.div<{
  flash: boolean;
}>`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  z-index: 1000;
  opacity: 0;
  animation: ${(props) => (props.flash ? flashAnimation : 'none')} ${FLASH_TIME}s ease-in-out;
`;

export const Photo = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;

  > img {
    max-width: 100%;
    max-height: 100%;
    object-fit: contain;
  }
`;

export const Container = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
`;

export const InfoPanel = styled.div`
  position: absolute;
  top: 0;
  left: 20px;
  display: flex;
  gap: 4px;
  flex-direction: column;
  z-index: 100;
`;

export const InfoText = styled.h2`
  ${({ theme }) => theme.typography.SEMI_BOLD_48};
  color: ${({ theme }) => theme.color[2]};
`;

export const WebcamContainer = styled.div<{ done: boolean }>`
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  ${(props) =>
    props.done &&
    css`
      filter: blur(4px);
    `}
  transition: all 0.3s;

  video {
    width: 100%;
    height: 100%;
    object-fit: contain;
    transform: ${SHOT_CONFIG.MIRROR_MODE ? 'scaleX(-1)' : 'none'}; /* MIRROR_MODE 설정에 따라 거울모드 적용 */
  }
`;

export const ProcessingOverlay = styled.div`
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.8);
  z-index: 2;
`;

export const ProcessingContent = styled.div`
  text-align: center;
`;

export const ProcessingTitle = styled.h3`
  ${({ theme }) => theme.typography.SEMI_BOLD_48};
  color: ${({ theme }) => theme.color[2]};
`;

export const ProcessingSubtitle = styled.h4`
  ${({ theme }) => theme.typography.REGULAR_24};
  color: ${({ theme }) => theme.color[2]};
`;

export const Spinner = styled.div`
  margin-top: 1.5rem;
  width: 3rem;
  height: 3rem;
  border-top: 4px solid #3b82f6;
  border-right: 4px solid transparent;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-left: auto;
  margin-right: auto;

  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export const FrameOverlay = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
  z-index: 1;

  img {
    height: 100%;
    object-fit: cover;
    opacity: 0.9;
  }
`;
